import { Vue } from 'vue-property-decorator';

import { bus } from '@/main';

export default class GlobalMixins extends Vue {
	answerIsCorrect(question: any, currentScreen: number): boolean {
		let userChoicesOfScreen = this.$store.getters.userChoices[currentScreen - 1]

		if (question.type === 'yes-no' || question.type === 'multiple-choice') {
			return userChoicesOfScreen === question.answer.value
		} else if (question.type === 'tags') {
			let answersMatch: boolean = true

			question.answer.value.forEach((answer: number) => {
				if (userChoicesOfScreen.indexOf(answer) === -1) {
					answersMatch = false
				}
			})

			if (question.answer.value.length !== userChoicesOfScreen.length) {
				answersMatch = false
			}

			return answersMatch
		} else if (question.type === 'draggable') {
			let userOrder = userChoicesOfScreen.map((item: any) => {
				return item.id
			})

			let draggableCorrect = false

			if (JSON.stringify(userOrder) === JSON.stringify(question.answer.value)) {
				draggableCorrect = true
			} else if (question.answer.altValue) {
				draggableCorrect = (JSON.stringify(userOrder) === JSON.stringify(question.answer.altValue))
			}

			return draggableCorrect
		}
		
		return false
	}
	openPrivacyPanel() {
		bus.$emit('togglePrivacyPanel', true)
	}
}
